import { PillTabs } from '../../../components/ui';
import { useAuth } from '../../../../utils/Auth/AuthProvider';
import { useSchoolGradeSubjects } from '../../../../react-query/queries';

interface Props {
  gradeId: number;
  value: number | 'all';
  onChange: (v: number | 'all') => void;
  allowAll: boolean;
  /** Only these subject ids are offered (a teacher's subjects for the class). */
  only?: number[] | null;
}

// The grade-subjects endpoint sends `subject_name`; older callers used `name`.
interface SubjectRow { id: number; name?: string; subject_name?: string }

/** Subject choice as horizontal overflow-paging pills (design). */
export default function SubjectPicker({ gradeId, value, onChange, allowAll, only }: Props) {
  const { token } = useAuth();
  const { data } = useSchoolGradeSubjects(token, gradeId ? String(gradeId) : '0');
  const subjects: SubjectRow[] = ((data?.subjects ?? []) as SubjectRow[])
    .filter((s) => !only || only.includes(s.id));

  const opts = [
    ...(allowAll ? [{ key: 'all', label: 'All subjects' }] : []),
    ...subjects.map((s) => ({ key: String(s.id), label: (s.subject_name || s.name || '') as string })),
  ];
  return (
    <PillTabs scroll dense label="Subject" value={String(value)} options={opts}
      onChange={(k) => onChange(k === 'all' ? 'all' : Number(k))} />
  );
}
